import React from "react";
import { Localizer } from "@/main/react/Types";
import { HomeFeedSelection, HomeOrderingStyle, HomeRange } from "./HomePageShared";
import { HomeFeedControls } from "./HomeFeedControls";

export function HomePageHeader(props: {
    localizer: Localizer;
    /**
     * HOME-FEED-29: the anchor the feed's "back to the controls" jump scrolls to. The controls sit in
     * page flow above card one on a list that never ends, so the deeper a member reads the further the
     * only way to change the feed recedes. The jump targets THIS row, not the document top.
     */
    controlRowRef?: React.Ref<HTMLElement>;
    showPersonalOptions?: boolean;
    selection: HomeFeedSelection;
    range: HomeRange;
    orderingStyle: HomeOrderingStyle;
    /** Where the All tab opens: the member's remembered all-feed sort (round 29, r29w2-home-2b B). */
    rememberedAllOrderingStyle?: HomeOrderingStyle;
    onSelectionChange: (value: HomeFeedSelection) => void;
    onRangeChange: (value: HomeRange) => void;
    onOrderingStyleChange: (value: HomeOrderingStyle) => void;
}) {
    const {
        localizer,
        showPersonalOptions = true,
        selection,
        range,
        orderingStyle,
        rememberedAllOrderingStyle,
        onSelectionChange,
        onRangeChange,
        onOrderingStyleChange,
        controlRowRef,
    } = props;

    return (
        <section ref={controlRowRef} className="mb-4 scroll-mt-20" data-playwright-id="home-hero">
            {/* SV-135 S5: the controls own their layout inside this row. For a member that is the
                full-width tab row (tabs, then the ghost sort and range triggers in its trailing slot);
                for an anonymous visitor it is the lone ghost sort trigger, start-aligned on a phone
                (`HOME-FEED-15`) and right-aligned from `sm` up. This row's classes are mirrored by the
                navigation skeleton (`PageNavigationTransition.spec.ts`), whose inner shape is S9's. */}
            <div className="flex min-h-9 items-center justify-end">
                <HomeFeedControls
                    localizer={localizer}
                    showPersonalOptions={showPersonalOptions}
                    selection={selection}
                    range={range}
                    orderingStyle={orderingStyle}
                    rememberedAllOrderingStyle={rememberedAllOrderingStyle}
                    onSelectionChange={onSelectionChange}
                    onRangeChange={onRangeChange}
                    onOrderingStyleChange={onOrderingStyleChange}
                />
            </div>
        </section>
    );
}
